module.exports = __webpack_public_path__ + "static/media/PaginationWidget.379e1335.scss";


//////////////////
// WEBPACK FOOTER
// ./src/frontend-standard-library/modules-react/Base/Component/PaginationWidget/PaginationWidget.scss
// module id = 964
// module chunks = 0